/**
 * Created by zhanghuan on 2016/12/15.
 * 公共方法类
 */
 function YunJi() {

}
var currentAjax = null; //当前请求的ajax

YunJi.prototype = {
  appUA: "",//app传过来的UserAgent,
  //basePath:"//t.yunjiweidian.com/yunjibuyer",
  basePath: "//" + window.location.host + "/yunjibuyer",
  weixinInfo: { //微信分享相关的信息
    title: "",
    desc: "",
    imgUrl: "",
    shareLink: ""
  },
  /**
   * rem单位计算
   * 设计稿是宽750，当一个div的宽是30px，转换rem为：30px/100px = 0.3rem
   * 设计稿是宽375，当一个div的宽是30px，转换rem为：30px*2/100px = 0.6rem
   */
  initRem() {
    var appUA = navigator.userAgent //app的UserAgent信息
    if (appUA && appUA.indexOf('{"appVersion') != -1) {
      YunJi.appUA = JSON.parse(appUA.substring(appUA.indexOf('{')))
    }

    /*rem控制不同屏幕显示大小*/
    YunJi.windowSize(document, window);
    window.onresize = function () {
      YunJi.windowSize(document, window);
    };
  },
  /**
   * 计算html字体font-size大小
   * @param doc document对象
   * @param win window对象
   */
  windowSize: function (doc, win) {
    var docEl = doc.documentElement,
      isIOS = navigator.userAgent.match(/iphone|ipod|ipad/gi),
      dpr = isIOS ? Math.min(win.devicePixelRatio, 3) : 1,
      dpr = window.top === window.self ? dpr : 1, //被iframe引用时，禁止缩放
      dpr = 1, // 首页引用IFRAME，强制为1
      scale = 1 / dpr,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    docEl.dataset.dpr = win.devicePixelRatio;
    if (navigator.userAgent.match(/iphone/gi) && screen.width == 375 && win.devicePixelRatio == 2) {
      docEl.classList.add('iphone6');
      //scale = 0.5;
    }
    if (navigator.userAgent.match(/iphone/gi) && screen.width == 414 && win.devicePixelRatio == 3) {
      docEl.classList.add('iphone6p');
      //scale = 0.3333333333333333;
    }
    var metaEl = doc.createElement('meta');
    metaEl.name = 'viewport';
    metaEl.content = 'initial-scale=' + scale + ',maximum-scale=' + scale + ', minimum-scale=' + scale;
    docEl.firstElementChild.appendChild(metaEl);
    //deviceWidth通过document.documentElement.clientWidth就能取到
    var recalc = function () {
      var width = document.body.clientWidth;
      if (width / dpr > 750) {
        width = 750 * dpr;
      }
      docEl.style.fontSize = 100 * (width / 750) + 'px';
    };
    recalc();
    if (!doc.addEventListener) return;
  },
  /**
   * rem转成px
   */
  remToPx: function (remNum) {
    let rootFontSize = Number.parseFloat(document.documentElement.style.fontSize);
    return remNum * rootFontSize;
  },
  /*获取 storage 缓存数据
	* type  类型   local：localStorage   session：sessionStorage
	* name  缓存数据name名
	*/
  getStorage(type,name){
    var type=type||'local'
    if(type=='local'){
      var result = localStorage.getItem(name)? localStorage.getItem(name):""
    }else if(type=='session'){
      var result = sessionStorage.getItem(name)? sessionStorage.getItem(name):""
    }
   return result;
  },

  /*设置 storage 缓存数据
  *type  类型   local：localStorage   session：sessionStorage
  *name  缓存数据name名
  *content  缓存的数据内容
  */
  setStorage(type,name,content){
    var type=type||'local'
    var data=content
    if(typeof(data)=='object'){ data=JSON.stringify(content) }
    if(type=='local'){
      localStorage.setItem(name,data)
    }else if(type=='session'){
      sessionStorage.setItem(name,data)
    }
  },
  /**
   * 调用app内部方法
   * eg:appCommonRule('20181224','reportLoadingCompletedJs',['1','2'])
   * 版本号日期，方法名，数组格式的参数
   * @param callback 回调传入app方法返回的值
   */
  appCommonRule(appIdForH5, methodName, value, callback) {
    // console.log('当前客户端版本为： ', YunJi.getversions())
    // console.log('当前页面为： ', 'xinyunpage')
    // console.log('获取到的csUseWKWeb', typeof YunJi.getcsUseWKWeb(), YunJi.getcsUseWKWeb(), Boolean(YunJi.getcsUseWKWeb()))

    if (YunJi.getversions() == '3.70.1021' && YunJi.appUA && YunJi.appUA.appClient == 'ios') {
      YunJi.newappCommonRule(20201021, methodName, value)
      return
    }
    
    if (parseInt(YunJi.getcsUseWKWeb(), 10) && YunJi.appUA && YunJi.appUA.appClient == 'ios') {
      YunJi.newappCommonRule(20201021, methodName, value)
      return
    }
    let appCont = YunJi.getUrlParams("appCont") || 0
    let backValue
    if ((parseInt(appCont) == 1 || parseInt(appCont) == 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
      // alert('yjapp[methodName]='+yjapp[methodName])
      if (typeof(yjapp) != "undefined" && typeof yjapp[methodName] == 'function') {
        // alert('这里把参数给app，参数为：'+value)
        if (value == undefined) {
          // backValue=eval("yjapp."+methodName+"()")
          backValue = yjapp[methodName]()
        } else {
          // backValue=eval("yjapp."+methodName+"("+value+")")
          backValue = yjapp[methodName](value)
        }
        backValue&&callback&&callback(backValue)
      } else {
        if (!YunJi.getPhoneType()) {
          YunJi.appRule(methodName, value)
        }
      }
    }
  },
  newappCommonRule(appIdForH5,methodName,value) {
    console.log('使用了新的调用规则:', methodName)
    const appCont = YunJi.getUrlParams('appCont') || 0
    if ((parseInt(appCont) == 1 || parseInt(appCont) == 2) && YunJi.appUA && YunJi.appUA.appIdForH5 >= appIdForH5) {
      if (JSON.stringify(value) == '{}' || value == undefined || value == '') {
        try {
          console.log('实际进来了1')
          window.webkit.messageHandlers[methodName].postMessage(null)
        } catch (e) {
          // console.log(e)
        }
      } else {
        try {
          console.log('实际进来了2')
          window.webkit.messageHandlers[methodName].postMessage(value)
        } catch (e) {
          // console.log(e)
        }
      }
    }
  },
  /**
  * app的Android低版本手机规则调用
  * eg:appRule('reportLoadingCompletedJs',['1','2'])
  * {methodName:'reportLoadingCompletedJs',value:['1','2']}
  */
  appRule(methodName,value){
    // prompt("{methodName:"+methodName+",value:"+value+"}");
  },
  /**
   * 获取url参数
   * @param param 参数名
   * @returns {*}
   */
  getUrlParams: function (param) {
    var ps = decodeURI(location.href);
    if (ps == '') return '';
    var params = (ps.substr(ps.lastIndexOf("?") + 1)).split("&");
    if (params != null) {
      for (var i = 0; i < params.length; i++) {
        var strs = params[i].split("=");
        if (strs[0] == param && strs[1]) {
          return strs[1];
        }
      }
    }
    return "";
  },
  /**
   * 获取url参数
   * @param url   用来获取参数的链接
   * @param param 参数名
   * @returns {*}
   */
  getRedirectUrlParams: function (url,param) {
    var ps = decodeURI(url);
    if (ps == '') return '';
    var params = (ps.substr(ps.lastIndexOf("?") + 1)).split("&");
    if (params != null) {
      for (var i = 0; i < params.length; i++) {
        var strs = params[i].split("=");
        if (strs[0] == param && strs[1]) {
          return strs[1];
        }
      }
    }
    return "";
  },
  /**
   * 设备类型
   */
  getPhoneType() {
    var result = false;
    var u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {//安卓手机
      result = false;
    } else if (u.indexOf('iPhone') > -1) {//苹果手机
      result = true;
    } else if (u.indexOf('Windows Phone') > -1) {//winphone手机
      result = false;
    } else if (u.indexOf('iPhone Simulator') > -1) {
      result = true;
    }
    return result;
  },
  /**
   * 是否是ipx
   */
  isIphoneX(){
    return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
  },
  /**
   * 传入版本号，如果当前客户端号 < 传入的版本号，则返回false布尔值
   */
  getVersionBool(version) {
    var appUA = navigator.userAgent; //app的UserAgent信息
    var appV = null
    if (appUA && appUA.indexOf('{"appVersion') != -1) {
      // alert(appV.appIdForH5)
      appV = JSON.parse(appUA.substring(appUA.indexOf('{')))
      if(!appV || appV.appIdForH5 < version ){
        return false
      }
      return true
    }
    return false
  },
  getversions() {
    let appV = {}
    const appUA = navigator.userAgent // app的UserAgent信息
    if (appUA && appUA.indexOf('{"appVersion') != -1) {
      appV = JSON.parse(appUA.substring(appUA.indexOf('{')))
    }
    return appV.appVersion
  },
  getcsUseWKWeb() {
    let appV = {}
    const appUA = navigator.userAgent // app的UserAgent信息
    if (appUA && appUA.indexOf('{"appVersion') != -1) {
      appV = JSON.parse(appUA.substring(appUA.indexOf('{')))
    }
    return appV.csUseWKWeb
  },
  /**
   * 获取cookie的函数
   */
  getCookie(cookieName) {
    const strCookie = document.cookie
    const arrCookie = strCookie.split('; ')
    for (let i = 0; i < arrCookie.length; i++) {
      const arr = arrCookie[i].split('=')
      if (cookieName == arr[0]) {
        return arr[1]
      }
    }
    return ''
  }
}
export default YunJi = new YunJi();